var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 12 7","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11 1.00012L6 6.00012L1 1.00012","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }